const lines = [
  [
    { t: "{", c: "text-slate-400" },
  ],
  [
    { t: '  "amount"', c: "text-sky-300" },
    { t: ": ", c: "text-slate-400" },
    { t: "2500", c: "text-emerald-300" },
    { t: ",", c: "text-slate-400" },
  ],
  [
    { t: '  "currency"', c: "text-sky-300" },
    { t: ": ", c: "text-slate-400" },
    { t: '"USD"', c: "text-amber-200" },
    { t: ",", c: "text-slate-400" },
  ],
  [
    { t: '  "destination"', c: "text-sky-300" },
    { t: ": {", c: "text-slate-400" },
  ],
  [
    { t: '    "country"', c: "text-sky-300" },
    { t: ": ", c: "text-slate-400" },
    { t: '"NG"', c: "text-amber-200" },
    { t: ",", c: "text-slate-400" },
  ],
  [
    { t: '    "type"', c: "text-sky-300" },
    { t: ": ", c: "text-slate-400" },
    { t: '"bank"', c: "text-amber-200" },
  ],
  [
    { t: "  },", c: "text-slate-400" },
  ],
  [
    { t: '  "reference"', c: "text-sky-300" },
    { t: ": ", c: "text-slate-400" },
    { t: '"SW-102849"', c: "text-amber-200" },
  ],
  [
    { t: "}", c: "text-slate-400" },
  ],
];

const CodeEditor = ({ title = "POST /v1/transfers" }) => (
  <div data-testid="code-editor" className="overflow-hidden rounded-2xl border border-white/10 bg-[#0F1B33] shadow-2xl shadow-black/30">
    <div className="flex items-center gap-2 border-b border-white/10 px-5 py-3.5">
      <span className="h-2.5 w-2.5 rounded-full bg-[#FF5F57]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#FEBC2E]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#28C840]" />
      <span className="ml-3 font-mono text-xs text-slate-400">{title}</span>
    </div>
    <div className="p-5 font-mono text-[13px] leading-6 sm:text-sm">
      <p className="mb-3 text-slate-500"># Create a transfer</p>
      {lines.map((segments, i) => (
        <div key={i} className="flex">
          <span className="w-8 select-none text-right text-slate-600">{i + 1}</span>
          <span className="pl-4">
            {segments.map((s, j) => (
              <span key={j} className={s.c}>{s.t}</span>
            ))}
          </span>
        </div>
      ))}
      <div className="mt-4 flex items-center gap-2 rounded-lg border border-emerald-400/20 bg-emerald-400/10 px-3 py-2">
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
        <span className="text-xs text-emerald-300">201 Created — transfer SW-102849 initiated</span>
      </div>
    </div>
  </div>
);

export default CodeEditor;
